import { z } from 'zod';

export const GanttViewTypeSchema = z.object({
  viewId: z.string(),
  type: z.literal('gantt'),
});

export const GanttRowSelectionSchema = z.object({
  selectionType: z.literal('row'),
  rowId: z.string(),
});

export const GanttBarSelectionSchema = z.object({
  selectionType: z.literal('bar'),
  rowId: z.string(),
});

export const GanttCellSelectionSchema = z.object({
  selectionType: z.literal('cell'),
  rowId: z.string(),
  columnId: z.string(),
  isEditing: z.boolean(),
});

export const GanttViewSelectionSchema = z.union([
  GanttRowSelectionSchema,
  GanttBarSelectionSchema,
  GanttCellSelectionSchema,
]);

export const GanttViewSelectionWithTypeSchema = z.union([
  z.intersection(GanttViewTypeSchema, GanttRowSelectionSchema),
  z.intersection(GanttViewTypeSchema, GanttBarSelectionSchema),
  z.intersection(GanttViewTypeSchema, GanttCellSelectionSchema),
]);

export type GanttRowSelection = z.TypeOf<typeof GanttRowSelectionSchema>;
export type GanttBarSelection = z.TypeOf<typeof GanttBarSelectionSchema>;
export type GanttCellSelection = z.TypeOf<typeof GanttCellSelectionSchema>;
export type GanttViewSelection = z.TypeOf<typeof GanttViewSelectionSchema>;
export type GanttViewSelectionWithType = z.TypeOf<
  typeof GanttViewSelectionWithTypeSchema
>;
